module.exports = __webpack_public_path__ + "static/media/skills.44e3bef4.svg";